package com.example.mystybag.login.views.views

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.common.extensions.keyboardPadding
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.common.views.CountryCodePickerBottomSheet
import com.example.mystybag.core.expected.rememberIsWebPortraitLayout
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.login.logic.MerchantRegistrationAddCompanyContactViewModel
import com.example.mystybag.login.views.components.MerchantRegistrationWebBoundedColumn

@Composable
fun MerchantRegistrationAddCompanyContactWebView(
    viewModel: MerchantRegistrationAddCompanyContactViewModel
) {
    val uiState by viewModel.uiState.subscribeAsState()
    val webPortrait = rememberIsWebPortraitLayout()
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        horizontalAlignment = Alignment.Start
    ) { _ ->
        Box(modifier = Modifier.fillMaxSize()) {
            MerchantRegistrationWebBoundedColumn(Modifier.fillMaxSize()) {
                if (webPortrait) {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .keyboardPadding()
                            .padding(bottom = p8)
                    ) {
                        Column(
                            modifier = Modifier
                                .weight(1f)
                                .fillMaxWidth()
                                .fillMaxHeight()
                                .verticalScroll(rememberScrollState())
                        ) {
                            MerchantRegistrationAddCompanyContactScrollableBody(viewModel)
                        }
                        MerchantRegistrationAddCompanyContactFooter(viewModel)
                    }
                } else {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .keyboardPadding()
                            .padding(bottom = p8)
                    ) {
                        MerchantRegistrationAddCompanyContactScrollableBody(viewModel)
                        MerchantRegistrationAddCompanyContactFooter(viewModel)
                    }
                }
            }

            CountryCodePickerBottomSheet(
                isVisible = uiState.showCompanyPhoneCountryPicker,
                countries = uiState.countries,
                selectedDialCode = uiState.companyDialCode,
                onCountrySelected = { country ->
                    viewModel.selectCompanyPhoneCountry(country.id, country.dialCode)
                },
                onDismiss = viewModel::hideCompanyPhoneCountryPicker
            )

            CountryCodePickerBottomSheet(
                isVisible = uiState.showCountryPicker,
                countries = uiState.countries,
                selectedCountryId = uiState.registeredCompanyCountryId,
                onCountrySelected = { country ->
                    viewModel.selectRegisteredCompanyCountry(country.id, country.name)
                },
                onDismiss = viewModel::hideCountryPicker
            )
        }
    }
}
